import React, { useEffect, useRef, useState } from "react";
import { FaRecordVinyl } from "react-icons/fa";
import {
  MUSIC_PURCHASE_OPTIONS,
} from "../../utils/Enum";
import ImageUtils from "../../utils/ImageUtils";
import { useAlert } from "../Alert/AlertContext";
import { useModal } from "../Modal/ModalContext";
import { SwerlVoucherPurchase } from "../PurchaseModal";
import ScrollToTop from "../ScrollToTop";
import { Theme } from "../WebsiteThemeElements";

import { getObjectLength } from "../../utils";
import { accAddressInfo } from "../../utils/xrpl";
import { getUserProfile } from "../GravatarAPI";
import {   BuyButton,
  CardContainer,
  CardContent,
  CardImg,
  CardTitle,
  CreatorImg,
  CreatorInfo,
  CreatorInfoContent,
  CreatorInfoWrapper,
  H6,
  InfoContentText,
  TextLink,SkeletonPurchaseCardImg } from "./CardElements";
import { PurchaseButton } from "./CardElements";
import { CardValueBadge } from "./CardElements";
import { VoucherDescription } from "./CardElements";
import { DividerLine } from "./CardElements";
import { PriceTag } from "./CardElements";
import { VoucherTitle } from "./CardElements";

export const  getAddressName = async(address) => {
      return await accAddressInfo(address).then(info => {
        if(info?.email){
          return getUserProfile(info?.email).then(profile => {
            if(profile){
              return {name: profile?.display_name,
              profileUrl: profile.avatar_url}
            }else{
              return address
            }
          })
        }else{
          return address
        }
  }).catch(err => {
    return address
   //console.error(err)
  })
}

const SwerlCollectionCard = ({ content }) => {
  const { modalContent, isOpen, openModal, closeModal } =
    useModal();
  const { defaultAlbumArt, DEFAULT_IMAGE } = ImageUtils();
  const [artistName, setArtistName] = useState(content?.issuer ? content?.issuer : '')
  const [profileImg, setProfileImg] = useState(DEFAULT_IMAGE(600))
  const { goTo } = ScrollToTop();
  const { addAlert } = useAlert();

  function buy() {
   openModal();
    modalContent(
      <SwerlVoucherPurchase
        type={MUSIC_PURCHASE_OPTIONS.NFT_PURCHASE}
        content={content}
      />
    );
  }

  useEffect(() => {
    displayArtistName()
    return () => {}
  }, [content?.issuer])

  const displayArtistName = async() => {
    let issuerName = await getAddressName(content?.issuer)
        if(getObjectLength(issuerName) > 0){
          setArtistName(issuerName?.name)
          setProfileImg(issuerName?.profileUrl + "?s=600&d=mp")
          return
        }
        setArtistName(issuerName)
        return
      
  }

  return (
    <>
      <CardContainer background={content?.color}>
         <div> <SkeletonPurchaseCardImg
          src={content?.cover?.url ? content?.cover?.url : defaultAlbumArt}
        />  
          <VoucherTitle>{`${content?.name}`}
          </VoucherTitle>
           <VoucherDescription>{content?.description}</VoucherDescription>
        </div>
        <CardContent>
          <DividerLine />
         
          <PriceTag>
                    {content?.price ? `${content?.price} USD` : "Pay Your Own Price"}
                  </PriceTag>
                
               
          
            <PurchaseButton
              onClick={
                () =>{
                  buy()
                }
                  
              }
            >
              Purchase Voucher
            </PurchaseButton>
          
        </CardContent>
      </CardContainer>
    </>
  );
};




export default SwerlCollectionCard;
